/* eslint-disable new-cap */
import { isIntercomInstalled } from '@seek/hirer-intercom-adapter';

export const updateIntercomMarkDataAttributeTrue = (type: string) => {
  if (isIntercomInstalled()) {
    window.Intercom!('update', { [type]: true });
  }
};

export const updateIntercomReferenceCheck = () => {
  if (isIntercomInstalled()) {
    window.Intercom!('trackEvent', 'cm_reference_check_pilot');
  }
};
